var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.999998 20.4243C0.999999 14.7843 5.57212 10.2122 11.2121 10.2122","stroke":"white","strokeWidth":"1.03692","key":0}),React.createElement("path",{"d":"M11.2121 10.2122C5.57212 10.2122 1 5.64004 1 3.95775e-05","stroke":"white","strokeWidth":"1.03692","key":1})]);
}

ArrowRight.defaultProps = {"width":"12","height":"21","viewBox":"0 0 12 21","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
